"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Encoding_1 = __importDefault(require("../Utils/Encoding"));
var UrlParser_1 = __importDefault(require("../Utils/UrlParser"));
var AppIdDomainExternalGenerator = /** @class */ (function () {
    function AppIdDomainExternalGenerator() {
    }
    AppIdDomainExternalGenerator.prototype.generate = function (elementConfig, attribute) {
        var externalContentId = elementConfig.attributes.get(attribute);
        var urlParser = new UrlParser_1.default(document.location.href);
        //Limpiamos el contentId
        externalContentId = Encoding_1.default.formatExternalData(externalContentId);
        externalContentId = encodeURIComponent(elementConfig.appid + "." + urlParser.getHost() + "." + externalContentId);
        elementConfig.attributes.set(attribute, externalContentId);
        return elementConfig;
    };
    return AppIdDomainExternalGenerator;
}());
exports.default = AppIdDomainExternalGenerator;
